import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Helmet, HelmetProvider } from "react-helmet-async";

const SEO = ({ title, titleTemplate, description, keywords, url }) => {
  const [siteInfo, setSiteInfo] = useState({
    site_name: "Elveè",
    logo: "https://backend.elveescrubs.com/media/site/Elvee_logo_yE42vg4.png",
    social_links: [],
  });

  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const res = await fetch(
          "https://backend.elveescrubs.com/688787d8ff144c502c7f5cffaafe2cc588d86079f9de88304c26b0cb99ce91c6/api/page/site-info/"
        );
        const data = await res.json();
        setSiteInfo(data);
      } catch (error) {
        console.error("Error fetching site info:", error);
      }
    };
    fetchSiteInfo();
  }, []);

  const fullTitle = titleTemplate ? `${title} | ${titleTemplate}` : title;
  const mainImage = siteInfo.logo;
  const siteName =  "Elveè";

  const schemaOrgJSONLD = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteName,
    url,
    logo: mainImage,
    sameAs: siteInfo.social_links
      ?.filter((s) => s.is_active)
      .map((s) => s.url) || [],
  };

  return (
    <HelmetProvider>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{fullTitle}</title>

        {/* Primary Meta */}
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={siteName} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={url} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={mainImage} />
        <meta property="og:url" content={url} />
        <meta property="og:site_name" content={siteName} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={mainImage} />

        {/* Favicon / Apple Touch */}
        <link rel="icon" type="image/png" href={mainImage} />
        <link rel="apple-touch-icon" href={mainImage} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgJSONLD)}
        </script>
      </Helmet>
    </HelmetProvider>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  titleTemplate: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  url: PropTypes.string,
};

SEO.defaultProps = {
  title: "Elveè Scrubs",
  titleTemplate: "Shop Premium Medical Scrubs",
  description:
    "Discover stylish, comfortable, and professional medical scrubs at Elveè. Perfect for healthcare heroes who want premium comfort and design.",
  keywords:
    "medical scrubs, nurse uniforms, healthcare apparel, doctor clothing, Elveè, Elvees Crubs, hospital wear, workwear, premium scrubs",
  url: "https://elveescrubs.com/",
};

export default SEO;
